import {Request} from "sp-react-commons";

import MovieHelpers from "../utils/MovieHelpers";

const baseUrl = `/api/${MovieHelpers.getLang()}`;

let MoviesRequest = Request.disableSpinner().disableTimeout();
MoviesRequest.Config.withCredentials = true;


export function nowbooking() {
    return MoviesRequest.get(`${baseUrl}/movies/nowbooking`);
}

export function newthisweek() {
    return MoviesRequest.get(`${baseUrl}/movies/newthisweek`);
}

export function get(id) {
    return MoviesRequest.get(`${baseUrl}/movies/${encodeURI( id )}`);
}



// WEBPACK FOOTER //
// ./js/movies/core/MoviesApi.js